import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import { getFieldValue } from '../../../utils';
import { ReviewerModal } from './additionalMandatoryReviewerModal';
import { ReviewerCardList } from '../ReviewerCardList/reviewerCardList';

export const AdditionalMandatoryReviewerField = (props: FieldProps) => {
  const { field, data, updater } = props;
  const { updateField, update } = updater;
  const value = getFieldValue(field, data);
  const [showModal, setShowModal] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleRemove = async (index: number) => {
    if (isLoading) return;
    const previousValue = JSON.parse(JSON.stringify(value));
    try {
      setIsLoading(true);
      updateField(
        field,
        value.filter((_, i) => i !== index)
      );
      await update();
    } catch (e) {
      console.error(
        'An unexpected error occurred while removing an additional mandatory reviewer',
        e
      );
      updateField(field, previousValue);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <FieldGroup
      {...props}
      value={null}
      disabled={false}
      componentRight={
        !props.disabled ? (
          <div className="fgl-link" onClick={() => setShowModal(true)}>
            {!!value?.length ? `Edit` : `Add`} Reviewers
          </div>
        ) : null
      }
    >
      <ReviewerCardList
        reviewers={value}
        disabled={props.disabled}
        isLoading={isLoading}
        onRemove={handleRemove}
      />
      {showModal && (
        <ReviewerModal
          data={data}
          onClose={() => setShowModal(false)}
          onSave={async reviewers => {
            updateField(field, reviewers);
            await update();
          }}
        />
      )}
    </FieldGroup>
  );
};
